import { render, staticRenderFns } from "./DriverMonitoringSystemSettings.vue?vue&type=template&id=a65e1816&scoped=true"
import script from "./DriverMonitoringSystemSettings.vue?vue&type=script&lang=js"
export * from "./DriverMonitoringSystemSettings.vue?vue&type=script&lang=js"
import style0 from "./DriverMonitoringSystemSettings.vue?vue&type=style&index=0&id=a65e1816&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a65e1816",
  null
  
)

export default component.exports